export default "<p>\r\n  content-media works!\r\n</p>\r\n"